<ul>
  <li *ngFor="let benefit of benefits">
    <a *ngIf="benefit.type === 'SimpleLinkComponent'; else text" [href]="benefit.url" [target]="benefit.newWindow ? '_blank' : '_self'">{{benefit.text}}</a>
    <ng-template #text>{{benefit.text}}</ng-template>
  </li>
</ul>
